var _a;
/**
 * ドリルタイプ定数
 * MEMO: next-lms-frontendの複製なので注意
 * EIGOは使用しない
 */
export var DrillType = {
    KOKUGO: 1,
    SANSU: 2,
    RIKA: 3,
    SHAKAI: 4,
    // EIGO: 5,
    KANJI: 6,
    ENDRILL: 7,
    ENWORK: 8,
    KANA: 9,
    CHUGAKU_KOKUGO: 101,
    CHUGAKU_SUGAKU: 102,
    CHUGAKU_ENDRILL: 103,
    CHUGAKU_RIKA: 104,
    CHUGAKU_CHIRI: 105,
    CHUGAKU_REKISHI: 106,
    CHUGAKU_KOUMIN: 107,
    CHUGAKU_GIJUTSU: 108,
    CHUGAKU_KATEI: 109,
    CHUGAKU_HOTAI: 110,
    CHUGAKU_ONGAKU: 111,
    CHUGAKU_BIJUTSU: 112,
    CHUGAKU_REVIEW_KOKUGO: 201,
    CHUGAKU_REVIEW_SANSU: 202,
};
/**
 * 教科定数
 * MEMO: next-lms-frontendの複製なので注意
 * KIROKUとALL_KYOKAは使用しない
 */
export var Subject = {
    // KIROKU: 0,
    KOKUGO: 1,
    SANSU: 2,
    RIKA: 3,
    SHAKAI: 4,
    EIGO: 5,
    CHUGAKU_KOKUGO: 101,
    CHUGAKU_SUGAKU: 102,
    CHUGAKU_ENDRILL: 103,
    CHUGAKU_RIKA: 104,
    CHUGAKU_SHAKAI: 105,
    CHUGAKU_JITSUGI: 106,
};
// ドリルタイプ関係の情報
// MEMO: next-lms-frontendの情報をまとめて記述しているだけであるため、注意
export var DRILL_TYPE_INFORMATION = (_a = {},
    _a[DrillType.KOKUGO] = {
        id: DrillType.KOKUGO,
        subjectId: Subject.KOKUGO,
        order: 10,
        name: 'KOKUGO',
        displayValue: {
            standard: '国語',
            withSchool: '小学国語',
            short: '国語',
            tab: '問題',
        },
    },
    _a[DrillType.SANSU] = {
        id: DrillType.SANSU,
        subjectId: Subject.SANSU,
        order: 20,
        name: 'SANSU',
        displayValue: {
            standard: '算数',
            short: '算数',
        },
    },
    _a[DrillType.RIKA] = {
        id: DrillType.RIKA,
        subjectId: Subject.RIKA,
        order: 30,
        name: 'RIKA',
        displayValue: {
            standard: '理科',
            withSchool: '小学理科',
            short: '理科',
        },
    },
    _a[DrillType.SHAKAI] = {
        id: DrillType.SHAKAI,
        subjectId: Subject.SHAKAI,
        order: 40,
        name: 'SHAKAI',
        displayValue: {
            standard: '社会',
            withSchool: '小学社会',
            short: '社会',
        },
    },
    _a[DrillType.KANJI] = {
        id: DrillType.KANJI,
        subjectId: Subject.KOKUGO,
        order: 12,
        name: 'KANJI',
        displayValue: {
            standard: '漢字練習',
            short: '漢字',
            tab: '漢字練習',
        },
    },
    _a[DrillType.ENDRILL] = {
        id: DrillType.ENDRILL,
        subjectId: Subject.EIGO,
        order: 50,
        name: 'ENDRILL',
        displayValue: {
            standard: '英語',
            withSchool: '小学英語',
            short: '英語',
            tab: '問題',
        },
    },
    _a[DrillType.ENWORK] = {
        id: DrillType.ENWORK,
        subjectId: Subject.EIGO,
        order: 51,
        name: 'ENWORK',
        displayValue: {
            standard: '英語',
            withSchool: '小学英語',
            short: '英語',
            tab: 'リスニング練習',
        },
    },
    _a[DrillType.KANA] = {
        id: DrillType.KANA,
        subjectId: Subject.KOKUGO,
        order: 11,
        name: 'KANA',
        displayValue: {
            standard: 'かな',
            short: 'かな',
            tab: 'かな',
        },
    },
    _a[DrillType.CHUGAKU_KOKUGO] = {
        id: DrillType.CHUGAKU_KOKUGO,
        subjectId: Subject.CHUGAKU_KOKUGO,
        order: 110,
        name: 'CHUGAKU_KOKUGO',
        displayValue: {
            standard: '国語',
            withSchool: '中学国語',
            short: '国語',
        },
    },
    _a[DrillType.CHUGAKU_SUGAKU] = {
        id: DrillType.CHUGAKU_SUGAKU,
        subjectId: Subject.CHUGAKU_SUGAKU,
        order: 120,
        name: 'CHUGAKU_SUGAKU',
        displayValue: {
            standard: '数学',
            short: '数学',
        },
    },
    _a[DrillType.CHUGAKU_ENDRILL] = {
        id: DrillType.CHUGAKU_ENDRILL,
        subjectId: Subject.CHUGAKU_ENDRILL,
        order: 130,
        name: 'CHUGAKU_ENDRILL',
        displayValue: {
            standard: '英語',
            withSchool: '中学英語',
            short: '英語',
        },
    },
    _a[DrillType.CHUGAKU_RIKA] = {
        id: DrillType.CHUGAKU_RIKA,
        subjectId: Subject.CHUGAKU_RIKA,
        order: 140,
        name: 'CHUGAKU_RIKA',
        displayValue: {
            standard: '理科',
            withSchool: '中学理科',
            short: '理科',
        },
    },
    _a[DrillType.CHUGAKU_CHIRI] = {
        id: DrillType.CHUGAKU_CHIRI,
        subjectId: Subject.CHUGAKU_SHAKAI,
        order: 150,
        name: 'CHUGAKU_CHIRI',
        displayValue: {
            standard: '地理',
            short: '地理',
            tab: '地理',
        },
    },
    _a[DrillType.CHUGAKU_REKISHI] = {
        id: DrillType.CHUGAKU_REKISHI,
        subjectId: Subject.CHUGAKU_SHAKAI,
        order: 151,
        name: 'CHUGAKU_REKISHI',
        displayValue: {
            standard: '歴史',
            short: '歴史',
            tab: '歴史',
        },
    },
    _a[DrillType.CHUGAKU_KOUMIN] = {
        id: DrillType.CHUGAKU_KOUMIN,
        subjectId: Subject.CHUGAKU_SHAKAI,
        order: 152,
        name: 'CHUGAKU_KOUMIN',
        displayValue: {
            standard: '公民',
            short: '公民',
            tab: '公民',
        },
    },
    // idの並び順とorderの並び順がかみ合わないが、正常である
    _a[DrillType.CHUGAKU_GIJUTSU] = {
        id: DrillType.CHUGAKU_GIJUTSU,
        subjectId: Subject.CHUGAKU_JITSUGI,
        order: 160,
        name: 'CHUGAKU_GIJUTSU',
        displayValue: {
            standard: '技術',
            short: '技術',
            tab: '技術',
        },
    },
    _a[DrillType.CHUGAKU_KATEI] = {
        id: DrillType.CHUGAKU_KATEI,
        subjectId: Subject.CHUGAKU_JITSUGI,
        order: 162,
        name: 'CHUGAKU_KATEI',
        displayValue: {
            standard: '家庭',
            short: '家庭',
            tab: '家庭',
        },
    },
    _a[DrillType.CHUGAKU_HOTAI] = {
        id: DrillType.CHUGAKU_HOTAI,
        subjectId: Subject.CHUGAKU_JITSUGI,
        order: 163,
        name: 'CHUGAKU_HOTAI',
        displayValue: {
            standard: '保体',
            short: '保体',
            tab: '保体',
        },
    },
    _a[DrillType.CHUGAKU_ONGAKU] = {
        id: DrillType.CHUGAKU_ONGAKU,
        subjectId: Subject.CHUGAKU_JITSUGI,
        order: 164,
        name: 'CHUGAKU_ONGAKU',
        displayValue: {
            standard: '音楽',
            short: '音楽',
            tab: '音楽',
        },
    },
    _a[DrillType.CHUGAKU_BIJUTSU] = {
        id: DrillType.CHUGAKU_BIJUTSU,
        subjectId: Subject.CHUGAKU_JITSUGI,
        order: 161,
        name: 'CHUGAKU_BIJUTSU',
        displayValue: {
            standard: '美術',
            short: '美術',
            tab: '美術',
        },
    },
    _a[DrillType.CHUGAKU_REVIEW_KOKUGO] = {
        id: DrillType.CHUGAKU_REVIEW_KOKUGO,
        subjectId: Subject.CHUGAKU_KOKUGO,
        order: 210,
        name: 'CHUGAKU_REVIEW_KOKUGO',
        displayValue: {
            standard: '復習国語',
            short: '小国',
        },
    },
    _a[DrillType.CHUGAKU_REVIEW_SANSU] = {
        id: DrillType.CHUGAKU_REVIEW_SANSU,
        subjectId: Subject.CHUGAKU_SUGAKU,
        order: 220,
        name: 'CHUGAKU_REVIEW_SANSU',
        displayValue: {
            standard: '復習算数',
            short: '小算',
        },
    },
    _a);
